/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import SVG from "react-inlinesvg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { isEditionAuthorized, isDeletionAuthorized, openEditActivityTypePage, deleteActivityTypes }
) => (
  <>
    {
      isEditionAuthorized &&
      <OverlayTrigger
        overlay={<Tooltip id="activity-type-edit-tooltip">Düzenle</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
          onClick={() => openEditActivityTypePage(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    }
    {
      isDeletionAuthorized &&
      <OverlayTrigger
        overlay={<Tooltip id="activity-types-delete-tooltip">Sil</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-danger btn-sm"
          onClick={() => deleteActivityTypes(row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-danger">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
        </a>
      </OverlayTrigger>
    }    
  </>
);